import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext"; // ✅ ADD THIS

function App() {
  return (
    <AuthProvider>
      <CartProvider> {/* ✅ ADD THIS WRAPPER */}
        <AppRoutes />
      </CartProvider>
    </AuthProvider>
  );
}

export default App;